import { Util } from '../utils/util';

export enum TipoDataEnum {
    DataAVP = 1,
    DataAVPDescription = 'Data de AVP',
    DataACI = 2,
    DataACIDescription = 'Data de ACI',
    DataRevogacao = 3,
    DataRevogacaoDescription = 'Data de Revogação',
    DataEmissao = 4,
    DataEmissaoDescription = 'Data de Emissão',
    DataInicioValidade = 5,
    DataInicioValidadeDescription = 'Data de Início Validade',
    DataVencimento = 6,
    DataVencimentoDescription = 'Data de Vencimento',
    DataInclusao = 7,
    DataInclusaoDescription = 'Data de Inclusão da Solicitação',
    DataPagamento = 9,
    DataPagamentoDescription = 'Data de Pagamento',
    DataInicioPeriodoUso = 10,
    DataInicioPeriodoUsoDescription = 'Data de Início do Período de Uso',
    DataFimPeriodoUso = 11,
    DataFimPeriodoUsoDescription = 'Data de Fim do Período de Uso',
    DataSolicitacaoPeriodoUso = 12,
    DataSolicitacaoPeriodoUsoDescription = 'Data da Solicitação do Período de Uso',
    DataFaturamento = 13,
    DataFaturamentoDescription = 'Data de Faturamento'
}

export namespace TipoDataEnum {
    /**
     * Gera um array de objetos para select com { enum: [valor], description: [descrição] }.
     * @param TipoDataEnum array de TipoDataEnum que deseja que mostre na lista.
     */
    export function values(listTipoDataEnum: TipoDataEnum[]) {
        return Object.keys(TipoDataEnum)
            .filter((type) => isNaN(<any>type) && type !== 'values' && !type.includes('Description') && listTipoDataEnum.some(value => value === +TipoDataEnum[type]))
            .map(item => {
                return { enum: +TipoDataEnum[item], description: Util.getEnumDescription(TipoDataEnum, +TipoDataEnum[item], 0) };
            });
    }
}
